// Convert a number (0 – 9,99,99,99,999) to Indian-style words.
// Used across amount input fields (Record Payment, Record Cash,
// Upload Slip, Rectify modal, etc.) so users can visually verify
// that the figure they typed is exactly what they intended.

const ONES = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven",
    "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen",
];

const TENS = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety",
];

function twoDigit(n) {
    if (n < 20) return ONES[n];
    const t = Math.floor(n / 10);
    const o = n % 10;
    return TENS[t] + (o ? " " + ONES[o] : "");
}

function threeDigit(n) {
    const h = Math.floor(n / 100);
    const rest = n % 100;
    const parts = [];
    if (h) parts.push(ONES[h] + " Hundred");
    if (rest) parts.push(twoDigit(rest));
    return parts.join(" ");
}

// Indian numbering: Crore · Lakh · Thousand · Hundred
export function numberToWordsIN(input) {
    if (input === "" || input === null || input === undefined) return "";
    const num = Number(input);
    if (isNaN(num)) return "";
    if (num === 0) return "Zero";
    if (!isFinite(num)) return "";

    const isNegative = num < 0;
    // Split whole rupees from paise (2-decimal support)
    const abs = Math.abs(num);
    const whole = Math.floor(abs);
    const paise = Math.round((abs - whole) * 100);

    const chunks = [];
    let w = whole;

    const crore = Math.floor(w / 10000000);
    w = w % 10000000;
    const lakh = Math.floor(w / 100000);
    w = w % 100000;
    const thousand = Math.floor(w / 1000);
    w = w % 1000;
    const rest = w;

    if (crore) chunks.push(twoDigit(crore) + " Crore");
    if (lakh) chunks.push(twoDigit(lakh) + " Lakh");
    if (thousand) chunks.push(twoDigit(thousand) + " Thousand");
    if (rest) chunks.push(threeDigit(rest));

    let words = chunks.join(" ").trim();
    if (!words) words = "Zero";
    words = "Rupees " + words;
    if (paise > 0) words += " and " + twoDigit(paise) + " Paise";
    words += " Only";
    if (isNegative) words = "Minus " + words;
    return words;
}

export default numberToWordsIN;
